module.exports = __webpack_public_path__ + "static/slide-5-8520948c6209d6a31f5dfd56342cde41.jpg";